import { createSlice } from '@reduxjs/toolkit';
import { SearchStatus } from '../../constants';

const initialState = {
  responses: {},
  status: SearchStatus.INITIAL,
};

const tourSlice = createSlice({
  name: 'tour',
  initialState,
  reducers: {
    tourSearchSuccess: (state, {
      payload: {
        response,
      },
    }) => ({
      ...state,
      status: SearchStatus.DONE,
      responses: {
        ...response,
      },
    }),
    updateTourSearchObj: (state, { payload: { searchStatus } }) => ({
      ...state,
      status: searchStatus,
    }),

  },
});

export const {
  tourSearchSuccess, updateTourSearchObj,
} = tourSlice.actions;
export default tourSlice.reducer;
